module.exports = __webpack_public_path__ + "img/location.40f6ab37.webp";